<interacta-community-picker-dialog
    [emptyLabel]="emptyLabel()"
    [isOpen]="isOpen()"
    [nameFilterControl]="
        communitiesTotalCount() > 20 ? nameFilterControl : undefined
    "
    [recentCommunities]="pickerRecentCommunities()"
    [workspaces]="pickerWorkspaces()"
    (closeDialog)="closeDialog.emit()"
    (communitySelected)="onCommunitySelected($event)"
/>
